<div class="modal-header modalHeaderBlack">
  <h6 class="modal-title">Verify OTP</h6>

  <span class="close" (click)="buttonClick()">
    <mat-icon>clear</mat-icon>
  </span>
</div>

<div class="otp-container">

  <p class="title">
    Enter the 6-digit OTP
  </p>

  <div class="otp-boxes">
   <input
    type="text"
    maxlength="6"
    [(ngModel)]="otp"
    inputmode="numeric"
    autocomplete="off">
  </div>

  <div class="action-row">

    <button
      mat-stroked-button
      color="primary"
      (click)="resendOtp()">
      Resend OTP
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="verifyOtp()">
      Verify
    </button>

  </div>

</div>